import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Submission from "@/pages/Submission";
import Results from "@/pages/Results";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { CookieBanner, RouteTracker } from "@/components/CookieBanner";

function AppRoutes() {
  const location = useLocation();
  return (
    <>
      <RouteTracker pathname={location.pathname} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/analyse" element={<Submission />} />
        <Route path="/results/:id" element={<Results />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/:slug" element={<GuideArticle />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
